<template>
    <hmenu></hmenu>

          <main>
            <section class="breadcrumb-height ns-breadcrumb-area" style="min-height: 300px; background-image: url('/assets/img/breadcrumb/breadcrumb-bg.jpg');" >
                <img src="/assets/img/breadcrumb/shape-1.png" alt="" class="ns-breadcrumb-shape-1">
                <img src="/assets/img/breadcrumb/breadcrumb-map.png" alt="" class="ns-breadcrumb-map">
                <img src="/assets/img/breadcrumb/shape-2.png" alt="" class="ns-breadcrumb-shape-2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="ns-breadcrumb-wrap text-center">
                                <h2 class="ns-breadcrumb-title">Menaxhimi i kontrollit te aksesit</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <div class="ns-project-details-area pt-115 pb-70">
                <div class="container">

                    <div class="row">

                        <div class="col-xl-4 col-lg-5 col-md-5">
                            <div class="ns-project-details-img-2 w_img mb-40">
                                <img src="/asetet/access.jpg" alt="">
                            </div>
                        </div>
                        
                        <div class="col-xl-8 col-lg-7 col-md-7">
                            <div class="ns-project-details-content mb-40">
                                <div class="ns-project-details-list">
                                    <h4>Kontroll i Aksesit i Avancuar për Biznese Moderne</h4>
                                    <p class="ns-project-details-text">GPRO ofron zgjidhje profesionale për kontrollin e aksesit, të dizajnuara për biznese, institucione dhe objekte që kërkojnë siguri, menaxhim të thjeshtë dhe fleksibilitet maksimal. Sistemi ynë kombinon pajisje moderne me softuer të avancuar në gjuhën shqipe, duke e bërë përdorimin dhe administrimin shumë të lehtë për çdo staf. </p>
                                    <div>
                                      <h4>Çfarë ofron sistemi i kontrollit të aksesit?</h4>
                                      <ul>
                                          <li>1. Menaxhim i hyrjeve dhe daljeve në kohë reale.</li>
                                          <li>2. Kontroll përmes kartelave, PIN-it, telefonit ose biometrisë.</li>
                                          <li>3. Evidentim i plotë i lëvizjeve dhe historikut të përdoruesve.</li>
                                          <li>4. Menaxhim i lehtë nga kompjuteri ose telefoni.</li>
                                          <li>5. Softuer i avancuar në gjuhën shqipe.</li>
                                          <li>6. Integrim me dyer automatike, barriera dhe sisteme sigurie.</li>
                                      </ul>
                                      <br>
                                      <br>
                                      <h4>Zgjidhje të personalizuara për çdo biznes</h4>
                                      <p class="ns-project-details-text">Çdo biznes funksionon ndryshe, prandaj edhe nevojat për siguri dhe kontroll janë specifike. Gpro ofron mundësinë që sistemi të përshtatet sipas kërkesave të klientit dhe logjikës së biznesit tuaj.
                                      <br>
                                      Nëse keni një ide specifike për mënyrën se si duhet të funksionojë kontrolli i aksesit në objektin tuaj, ekipi ynë mund ta zhvillojë dhe personalizojë sistemin sipas atyre kërkesave.</p>
                                    </div>

                                    <div>
                                      <h4>Ideale për:</h4>
                                      <ul>
                                          <li>1. Biznese dhe zyra.</li>
                                          <li>2. Parkingje dhe objekte private.</li>
                                          <li>3. Banesa kolektive.</li>
                                          <li>4. Shkolla dhe institucione.</li>
                                          <li>5. Hotele dhe ambiente industriale.</li>
                                      </ul>
                                      <p class="ns-project-details-text">Me Gpro, kontrolli i aksesit bëhet më i thjeshtë, më i sigurt dhe plotësisht i përshtatur për mënyrën se si funksionon biznesi juaj.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                    </div>








                </div>
            </div>


        </main>


    <Footer></Footer>
</template>

<script>
    import hmenu from './header.vue'
    import Footer from './Footer.vue'

    export default {

        data () {
            return {
               selected:'kioska'
            }
        },


        methods:{

            tabClick(type){
                this.selected = type
            }

        },

        mounted:function(){

        },


        components: {
            hmenu,
            Footer,
         
        },


        mounted:function(){
            window.scrollTo({top: 0, behavior: 'smooth'});
        }


    }

</script>

